export const data = function() {
  return {
    isDebug: true,
    loading: false,
    mailDeliveryItemID: 0,
    mailingID: 0,
    deliveryItemTitle: '',
    mailDeliveryItem: null,
    tabs: [
      { name: 'itemDetails', label: 'Detail' },
      { name: 'itemEvents', label: 'Events' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
